// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__1x5iw"};